import gql from "graphql-tag";

const DeleteProjectSpecialConditionTypeMapping = gql`
  mutation deleteProjectSpecialConditionTypeMapping($projectId: uuid!, $model: String!, $typeIdentifier: String!) {
    delete_projectSpecialConditionTypeMapping(
      where: { projectId: { _eq: $projectId }, model: { _eq: $model }, typeIdentifier: { _eq: $typeIdentifier } }
    ) {
      affected_rows
    }
  }
`;

export default DeleteProjectSpecialConditionTypeMapping;
